module.exports = __webpack_public_path__ + "img/Rectangle_17P.4d32fd25.png";